import React from 'react';
import { withRouter } from 'react-router-dom';
import * as moment from 'moment';
import {
    Container,
    Button,
} from 'reactstrap';
import { CircularProgress } from '@mui/material';
import cls from 'classnames';
import CommonContext, { ApiRoutes, LocalizationKeys as l } from '../Common';
import {
    FlexColumnCenter,
    FlexCenterRow,
    FlexStartRow,
    FlexEndRow,
    SmallButton,
    toasty,
} from '../common/forms/FormElements';

import { util } from '../Util';
import './TimesheetForm.scss';
import TimesheetItem from './TimesheetItem';
import ClientReview from './ClientReview';
import EmployeeReview from './EmployeeReview';
import EmployeeReviewAll from './EmployeeReviewAll';
import authService from '../api-authorization/AuthorizeService';
// import { TimesheetStatus } from './Timesheet';
import { RejectionNote, ClientCancelled, TimesheetStatus } from './Timesheet';
import {
    ContractTimesheetResponsibilityType,
    TimesheetResponsibilityType,
} from '../tenant/Tenant';

export const ConfirmationStatus = {
    Unfilled: 1,
    Scheduled: 2,
    NoResponse: 3,
    Confirmed: 4,
    CancelPending: 5,
    ThresholdCancel: 6,
};

class TimesheetDetailsForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.timesheetItemRef = React.createRef();
        this.timesheetClientReviewRef = React.createRef();
        this.timesheetEmployeeReviewRef = React.createRef();
        this.timesheetEmployeeReviewAllRef = React.createRef();

        this.state = {
            assignment: null,
            confirmedAssignments: [],
            invalidChargeTypeIds: [],
            jobDetailsOpen: false,
            loading: true,
            notFound: false,
            timesheetOpen: false,
            timesheetClientReviewOpen: false,
            timesheetEmployeeReviewAllOpen: false,
            timesheet: {},
            timesheetId: null,
            showLinkedTimesheetModal: false,
            isSavingLinkedTimesheet: false,
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    onAddTimesheet = async (chargeTypeId) => {
        const { timesheetId } = this.state;
        this.setState({ isSavingLinkedTimesheet: true });

        const result = await util.fetch.post(
            ApiRoutes.timesheet.createLinkedTimesheet(timesheetId, chargeTypeId),
        );

        if (result) {
            toasty.success('Timesheet added.');
        } else {
            let error = 'Error adding timesheet.';
            if ((result ?? {}).error) {
                error = result.error;
            }
            toasty.error(error);
        }

        this.setState({
            isSavingLinkedTimesheet: false,
            showLinkedTimesheetModal: false,
        });
        await this.refresh();
    };

    onTimesheetClientReviewClosed = async () => {
        await this.context.setFormOpened(false);

        await this.refresh();
    };

    onTimesheetEmployeeReviewClosed = async () => {
        await this.context.setFormOpened(false);

        await this.refresh();
    };

    onTimesheetEmployeeReviewAllSaved = async () => {
        await this.context.setFormOpened(false);

        const { timesheet } = this.state;
        var returnUrl = '';
        if (timesheet?.jobStartTime != null) {
            var j = timesheet?.jobStartTime.indexOf(' ');
            var dt = timesheet?.jobStartTime.substring(0, j);
            returnUrl = '/dailyDrivingLog/' + moment(dt).format('YYYYMMDD');
        }

        if (returnUrl.length > 0)
            window.location.replace(returnUrl);
    };

    onTimesheetEmployeeReviewAllClosed = async () => {
        await this.context.setFormOpened(false);
    };

    onTimesheetItemClosed = async () => {
        await this.context.setFormOpened(false);

        await this.refresh();
    };

    async openTimesheet(id) {
        const { timesheet } = this.state;

        if (timesheet.isApproved)
            return;

        if (id) {
            await this.context.setFormOpened(true);
            this.timesheetItemRef.current.open(id);
        }
    }

    async openTimesheetClientReview(id) {
    // This should only open up once all billable charges on TS have time or NA.
    // It can also be opened up to view once its been filled out to review if needed(basically same as above).

        if (id) {
            await this.context.setFormOpened(true);
            this.timesheetClientReviewRef.current.open(id);
        }
    }

    async openTimesheetEmployeeReview(timesheet) {
        if (timesheet) {
            await this.context.setFormOpened(true);
            this.timesheetEmployeeReviewRef.current.open(timesheet.id, timesheet.employeeId);
        }
    }

    async openTimesheetEmployeeReviewAll() {
        const { timesheetId } = this.state;

        await this.context.setFormOpened(true);
        this.timesheetEmployeeReviewAllRef.current.open(timesheetId);
    }

    getTotalHours = (timesheets) => {
        var totalHours = 0;

        for (var t = 0; t < timesheets.length; t++) {
            var ts = timesheets[t];
            totalHours += ts.value;
            
        }

        return totalHours;
    }

    getTotalTonnageHours = (timesheets) => {

        const tonnageTimesheets = timesheets.filter((x) => x.isTonnage == true);

        var totalHours = 0.0;
        var start = null;
        for (var i = 0; i < tonnageTimesheets.length; i++) {
            var ts = tonnageTimesheets[i];

            if (start == null && ts.startTime != null) {
                start = ts.startTime;
            }

            if (ts.endTime != null) {
                var startDt = moment(start);
                var endDt = moment(ts.endTime);

                // Handle midnight-crossing entries: when the end datetime ends
                // up before the start datetime, the end was anchored to the
                // wrong day. Roll it forward day-by-day until it's after the
                // start so the duration comes out positive instead of negative.
                while (endDt.isBefore(startDt)) {
                    endDt.add(1, 'day');
                }

                var duration = moment.duration(endDt.diff(startDt));
                totalHours += duration.asHours();

                start = null;
            }

        }

        if (isNaN(totalHours))
            totalHours = 0;

        return totalHours;
    }

    getTotalTonnage = (timesheets) => {

        const tonnageTimesheets = timesheets.filter((x) => x.isTonnage == true);

        var totalTons = 0.0;
        for (var i = 0; i < tonnageTimesheets.length; i++) {
            var ts = tonnageTimesheets[i];
            totalTons += ts.value;
        }

        return totalTons;
    }

    populateState = async () => {
        const isAuthenticated = await authService.isAuthenticated();
        if (isAuthenticated) {
            const timesheetId = this.props.match.params.id;
            const assignmentId = this.props.location.state !== undefined
                && Object.prototype.hasOwnProperty.call(this.props.location.state, 'assignmentId')
                ? this.props.location.state.assignmentId
                : 0;

            const strings = await util.l10n.getStrings([l.crewLead]);
            this.setState({ strings });

            if (!timesheetId) {
                this.setState({ notFound: true, loading: false });
                return;
            }

            // Timesheet
            const timesheet = await util.fetch.js(
                ApiRoutes.timesheet.overviewDetail(timesheetId),
            );
            if (!timesheet) {
                this.setState({ notFound: true, loading: false });
                return;
            }

            // TEMP: diagnostic for "Incomplete" badge on cross-midnight entries.
            // Shows what the server sends back so we can see the complete flag
            // and the time fields it's basing the flag on.
            console.log('[populateState] timesheets from server:', timesheet?.timesheets?.map(ts => ({
                workOrderNumber: ts.workOrderNumber,
                isTonnage: ts.isTonnage,
                startTime: ts.startTime,
                endTime: ts.endTime,
                value: ts.value,
                timesheetDetailsComplete: ts.timesheetDetailsComplete,
            })));

            timesheet.clientReviewPopoverOpen = false;
            timesheet.crewReviewPopoverOpen = false;

            // Charge Type sections
            const sections = await util.fetch.js(
                ApiRoutes.dailyDrivingLog.getTimesheetEquipmentSections(timesheetId),
            );

            // Assignment
            let enforceCrewLeadTS = false;
            let assignment = null;

            if (assignmentId > 0) {
                assignment = await util.fetch.js(
                    ApiRoutes.jobAssignment.byId(assignmentId),
                );
                if (assignment) {
                    enforceCrewLeadTS = this.context.tenant.tenantSettings
                        .timesheetResponsibilityType
                            === TimesheetResponsibilityType.CrewLead
                        || (this.context.tenant.tenantSettings
                            .timesheetResponsibilityType
                            === TimesheetResponsibilityType.Contract
                            && assignment.contractTimesheetResponsibilityTypeId
                                === ContractTimesheetResponsibilityType.CrewLead);
                }
            }

            this.setState({
                sections,
                timesheet,
                assignment,
                jobDetailsOpen: true,
                timesheetId,
                loading: false,
                enforceCrewLeadTimesheet: enforceCrewLeadTS
            });
        }
    };

    refresh = async () => {
        const { timesheetId } = this.state;
        const timesheet = await util.fetch.js(
            ApiRoutes.timesheet.overviewDetail(timesheetId),
        );

        if (!timesheet) this.setState({ notFound: true, loading: false });

        // create review items for the signature grids

        this.setState({
            timesheet,
            jobDetailsOpen: true,
            loading: false,
        });
    };

    onSubmitTickets = async () => {
        const { timesheet, timesheetId } = this.state;

        // Validate to see if we have an end date on tonnage ranges
        const tonnageTimesheets = timesheet.timesheets.filter((x) => x.isTonnage == true && x.linkedTimesheetSequence != null);

        if (tonnageTimesheets.length > 0 && tonnageTimesheets[tonnageTimesheets.length - 1].endTime == null) {
            toasty.error('Please provide a tonnage end time');
            return;
        }
        
        await this.context.setFormOpened(true);
        this.timesheetEmployeeReviewAllRef.current.open(timesheetId);

        this.setState({ timesheetEmployeeReviewAllOpen: true });
    }

    toggleLinkedTimesheetModal = () => {
        const { showLinkedTimesheetModal } = this.state;
        this.setState({ showLinkedTimesheetModal: !showLinkedTimesheetModal });
    };

    render() {
        const {
            sections,
            timesheet,
            loading,
            notFound
        } = { ...this.state };

        if (!!loading || !(this.context.tenant ?? {}).tenantSettings) {
            return (
                <div className="confirmationContainer h-100 pt-2 d-flex flex-row align-items-center justify-content-center">
                    <CircularProgress
                        color="secondary"
                        variant="indeterminate"
                    />
                </div>
            );
        }
        const { tenantSettings } = { ...this.context.tenant };

        // Split timesheets by type
        const hourlyTimesheets = timesheet.timesheets.filter((x) => x.isTonnage !== true && x.linkedTimesheetSequence != null);
        const tonnageTimesheets = timesheet.timesheets.filter((x) => x.isTonnage == true && x.linkedTimesheetSequence != null);

        const hoursTotal = this.getTotalHours(hourlyTimesheets);
        const tonnageHoursTotal = this.getTotalTonnageHours(tonnageTimesheets);
        const tonnageTotal = this.getTotalTonnage(tonnageTimesheets);

        var isValidSubmit = true;

        // Hourly validation
        for (var h = 0; h < hourlyTimesheets.length; h++) {
            if (!hourlyTimesheets[h].timesheetDetailsComplete) {
                isValidSubmit = false;
                break;
            }
        }

        if (isValidSubmit) {
            // Tonnage validation
            for (var t = 0; t < tonnageTimesheets.length; t++) {
                if (tonnageTimesheets[t].workOrderNumber.length == 0 || (tonnageTimesheets[t].startTime == null && tonnageTimesheets[t].endTime == null)) {
                    isValidSubmit = false;
                    break;
                }
            }
        }

        var returnUrl = '';
        if (timesheet?.jobStartTime != null) {
            returnUrl = '/timesheet/' + this.props.match.params.id;
        } 

        var primaryTimesheet = null;
        for (var pt = 0; pt < timesheet.timesheets.length; pt++) {
            if (timesheet.timesheets[pt].linkedTimesheetSequence == null) {
                primaryTimesheet = timesheet.timesheets[pt];
                break;
            }
        }

        var inGroup = false;

        return (
            <>
                <div
                    className={cls('confirmationContainer h-100 pt-2', {
                        'site-form-disabled': !!this.context.formIsOpen,
                    })}
                >
                    <Container size="sm">
                        {!!notFound && (
                            <h4 className="text-center">
                Unable to locate the requested resource.
                            </h4>
                        )}
                        {!!timesheet && (
                            <>
                                {(timesheet ?? {}).isClientCancelled && (
                                    <FlexColumnCenter className="pb-3">
                                        <ClientCancelled />
                                    </FlexColumnCenter>
                                )}
                                {(timesheet ?? {}).timesheetStatusId
                                        === TimesheetStatus.Rejected && (
                                    <FlexColumnCenter className="pb-3">
                                        <RejectionNote
                                            note={
                                                timesheet.lastRejectionNote
                                            }
                                        />
                                    </FlexColumnCenter>
                                )}
                                <a style={{ paddingLeft: '0px' }} href={returnUrl} className="btn site-link">&lt;&nbsp;Previous</a>

                                <FlexStartRow>
                                    <div className="overviewStats">
                                        <table style={{ width: '100%' }}>
                                            <tr>
                                                <td class="overviewStatsHeader" align="right" width="70">Hourly:</td>
                                                <td align="right" width="70">&nbsp;{hoursTotal.toFixed(2)} hrs</td>
                                                <td class="overviewStatsTotal" align="center">{(hoursTotal + tonnageHoursTotal).toFixed(2)} Hours</td>
                                            </tr>
                                            <tr>
                                                <td class="overviewStatsHeader" align="right">Tonnage:</td>
                                                <td align="right">&nbsp;{tonnageHoursTotal.toFixed(2)} hrs</td>
                                                <td class="overviewStatsTotal" align="center">{tonnageTotal.toLocaleString()} Tons</td>
                                            </tr>

                                        </table>
                                    </div>
                                </FlexStartRow>

                                {primaryTimesheet != null &&
                                    <>

                                        {sections.map((section, i) => {

                                            var timesheets = timesheet.timesheets.filter((x) => x.chargeTypeSection == section.id);
                                            var isTonnage = timesheets.filter((x) => x.isTonnage == true).length > 0;

                                            return (
                                                <>
                                                    <h4 style={{ marginTop: '16px', marginBottom: '0px' }}>
                                                        <FlexStartRow>{section.description}</FlexStartRow>

                                                        {!timesheet?.isApproved &&
                                                            <FlexEndRow>
                                                                <SmallButton
                                                                    type="button"
                                                                    className="ml-1"
                                                                    title=""
                                                                    onClick={(e) => this.onAddTimesheet(section.id)}
                                                                >
                                                                    <i className="fa fa-plus-circle fa-lg mr-1" />
                                                                    Add Ticket
                                                                </SmallButton>
                                                            </FlexEndRow>
                                                        }
                                                    </h4>

                                                    {isTonnage != true &&
                                                        <table width="100%">
                                                            <tbody>
                                                                {!(timesheets ?? [])
                                                                    .length ? (
                                                                        <tr>
                                                                            <td
                                                                                colSpan="4"
                                                                                className="text-center"
                                                                            >
                                                                                No tickets found.
                                                                            </td>
                                                                        </tr>
                                                                    ) : (
                                                                        timesheets.map(
                                                                            (ts, i) => {

                                                                                const sequence = ts.linkedTimesheetSequence == null ? '' : '-' + ts.linkedTimesheetSequence;

                                                                                var timeSpan = '';
                                                                                if (ts.startTime != null)
                                                                                    timeSpan += moment(ts.startTime).format('h:mm a');

                                                                                if (timeSpan.length > 0) timeSpan += ' - ';

                                                                                if (ts.endTime != null)
                                                                                    timeSpan += moment(ts.endTime).format('h:mm a');

                                                                                return (
                                                                                    <tr onClick={() => this.openTimesheet(ts.id)} key={ts.id} style={{ borderBottom: '2px solid lightgray' }}>
                                                                                        <td style={{ paddingTop: '8px', paddingBottom: '8px' }} className="d-flex flex-row align-items-start">
                                                                                            <span className="site-link">
                                                                                                {`${ts.jobNumber}${sequence}`}
                                                                                            </span>
                                                                                            &nbsp;&nbsp;
                                                                                            <span style={{ padding: '2px', fontSize: '12px' }}>{timeSpan}</span>
                                                                                        </td>
                                                                                        <td align="right" width="100">
                                                                                            {ts.timesheetDetailsComplete &&
                                                                                                <span style={{ fontSize: '12px' }} className="badge badge-success">
                                                                                                    Complete
                                                                                                </span>
                                                                                            }
                                                                                            {!ts.timesheetDetailsComplete &&
                                                                                                <span style={{ fontSize: '12px' }} className="badge badge-danger">
                                                                                                    Incomplete
                                                                                                </span>
                                                                                            }

                                                                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                                                                            <span style={{ fontSize: '11px' }} class="fa fa-play"></span>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            },
                                                                        )
                                                                    )}
                                                            </tbody>
                                                        </table>
                                                    }

                                                    {isTonnage == true && 
                                                        <table width="100%">
                                                            <tbody>
                                                                {!(timesheets ?? [])
                                                                    .length ? (
                                                                        <tr>
                                                                            <td
                                                                                colSpan="4"
                                                                                className="text-center"
                                                                            >
                                                                                No tickets found.
                                                                            </td>
                                                                        </tr>
                                                                    ) : (

                                                                        timesheets.map(
                                                                            (ts, i) => {

                                                                                const sequence = ts.linkedTimesheetSequence == null ? '' : '-' + ts.linkedTimesheetSequence;

                                                                                var timeSpan = '';
                                                                                if (ts.startTime != null)
                                                                                    timeSpan += moment(ts.startTime).format('h:mm a');

                                                                                if (i > 0 && ts.startTime == tonnageTimesheets[i - 1].startTime && ts.endTime == null)
                                                                                    timeSpan = '';

                                                                                if (timeSpan.length > 0 && ts.endTime != null) timeSpan += ' - ';

                                                                                if (ts.endTime != null)
                                                                                    timeSpan += moment(ts.endTime).format('h:mm a');

                                                                                var grouped = 'tonnageNonGrouping';
                                                                                if (ts.startTime != null) {
                                                                                    inGroup = true;
                                                                                }

                                                                                if (inGroup)
                                                                                    grouped = 'tonnageGrouping';

                                                                                if (ts.endTime != null) {
                                                                                    inGroup = false;
                                                                                }

                                                                                if (i > 0 && tonnageTimesheets[i - 1].endTime == null && ts.endTime != null)
                                                                                    timeSpan = moment(ts.endTime).format('h:mm a');

                                                                                return (
                                                                                    <>
                                                                                        <tr className={grouped} onClick={() => this.openTimesheet(ts.id)} key={ts.id}>
                                                                                            <td style={{ paddingLeft: '4px', fontWeight: 'bold' }}>{timeSpan}</td>

                                                                                            <td style={{ paddingTop: '8px', paddingBottom: '8px' }} className="d-flex flex-row align-items-start">
                                                                                                <span className="site-link">
                                                                                                    {`${ts.jobNumber}${sequence}`}
                                                                                                </span>

                                                                                            </td>
                                                                                            <td align="right" width="100">
                                                                                                {(ts.workOrderNumber.length > 0 && (ts.startTime != null || ts.endTime != null)) &&
                                                                                                    <span style={{ fontSize: '12px' }} className="badge badge-success">
                                                                                                        Complete
                                                                                                    </span>
                                                                                                }
                                                                                                {(ts.workOrderNumber.length == 0 || (ts.startTime == null && ts.endTime == null)) &&
                                                                                                    <span style={{ fontSize: '12px' }} className="badge badge-danger">
                                                                                                        Incomplete
                                                                                                    </span>
                                                                                                }
                                                                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                                                                <span style={{ fontSize: '11px' }} class="fa fa-play"></span>

                                                                                            </td>
                                                                                        </tr>

                                                                                        {ts.endTime != null &&
                                                                                            <tr><td>&nbsp;</td></tr>
                                                                                        }
                                                                                    </>
                                                                                );
                                                                            },
                                                                        )
                                                                    )}
                                                            </tbody>
                                                        </table>
                                                    }
                                                </>

                                            );
                                        })}

                                        
                                    </>
                                }
      
                                
                            </>
                        )}
                        
                    </Container>
                </div>

                {!timesheet?.isApproved &&
                    <FlexCenterRow className="userActions p-1">
                        <Button
                            type="button"
                            color="success"
                            id="addChargesButton"
                            disabled={!isValidSubmit}
                            onClick={() => this.onSubmitTickets()}
                        >
                            Submit
                        </Button>
                    </FlexCenterRow>
                }

                <TimesheetItem
                    ref={this.timesheetItemRef}
                    show={this.state.timesheetOpen}
                    toggleShow={(open) => this.setState({ timesheetOpen: open })}
                    onClose={this.onTimesheetItemClosed}
                />
                <ClientReview
                    tenantSettings={tenantSettings}
                    ref={this.timesheetClientReviewRef}
                    show={this.state.timesheetClientReviewOpen}
                    toggleShow={(open) => this.setState({ timesheetClientReviewOpen: open })}
                    onClose={this.onTimesheetClientReviewClosed}
                />
                <EmployeeReview
                    tenantSettings={tenantSettings}
                    ref={this.timesheetEmployeeReviewRef}
                    show={this.state.timesheetEmployeeReviewOpen}
                    toggleShow={(open) => this.setState({ timesheetEmployeeReviewOpen: open })}
                    onClose={this.onTimesheetEmployeeReviewClosed}
                />
                <EmployeeReviewAll
                    tenantSettings={tenantSettings}
                    ref={this.timesheetEmployeeReviewAllRef}
                    show={this.state.timesheetEmployeeReviewAllOpen}
                    toggleShow={(open) => this.setState({ timesheetEmployeeReviewAllOpen: open })}
                    onClose={this.onTimesheetEmployeeReviewAllClosed}
                    onSaved={this.onTimesheetEmployeeReviewAllSaved}
                    hourlyTimesheets={hourlyTimesheets}
                    tonnageTimesheets={tonnageTimesheets}
                    hoursTotal={hoursTotal}
                    tonnageHoursTotal={tonnageHoursTotal}
                    tonnageTotal={tonnageTotal}
                />
            </>
        );
    }
}

export default withRouter(TimesheetDetailsForm);
